import { Box, Paper as MuiPaper } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Paper = styled(MuiPaper)`
  ${({ theme }) => css`
    width: 630px;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 10px 0 0 10px;
    background: ${theme.colors.lightest};
  `}
`

export const Header = styled(Box)`
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
`

// O Breadcrumb compartilhado corta em uma linha (nowrap + overflow hidden); no drawer, nomes de
// filial longos quebram linha
export const BreadcrumbBox = styled(Box)`
  flex: 1;
  min-width: 0;

  & > div {
    flex-wrap: wrap;
    white-space: normal;

    &::before {
      content: none;
    }
  }

  & > div > div {
    line-height: 24px;
  }
`

export const CloseButton = styled(Box)`
  display: flex;
  flex-shrink: 0;
  padding-top: 1px;
  cursor: pointer;
`

export const Content = styled(Box)`
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 8px 24px 24px;
`

export const TitleRow = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
`

export const Title = styled(Box)`
  ${({ theme }) => css`
    font-size: 22px;
    font-weight: 600;
    color: ${theme.colors.secondary};
  `}
`

export const CompetenceBadge = styled(Box)`
  ${({ theme }) => css`
    padding: 1px 6px;
    border: 1px solid ${theme.colors.primary};
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    color: ${theme.colors.primary};
  `}
`

export const WeekBadge = styled(Box)`
  ${({ theme }) => css`
    margin-left: auto;
    padding: 2px 24px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
    color: ${theme.colors.lightest};
    background: ${theme.colors.primary};
  `}
`

// Linha fina entre contas (mesmo divisor do Histórico de Prévias da Gestão da Prévia)
export const AccountSection = styled(Box)`
  ${({ theme }) => css`
    & + & {
      padding-top: 16px;
      border-top: 1px solid ${theme.colors.border.light};
    }
  `}
`

export const AccountTitle = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 0;
    border: none;
    background: none;
    font-family: inherit;
    font-size: 18px;
    font-weight: 600;
    color: ${theme.colors.secondary};
    cursor: pointer;

    & > svg:last-child {
      margin-left: auto;
      transition: transform 0.2s;
    }
  `}
`

export const AccountBody = styled(Box)`
  padding-top: 24px;
`

// Mesmo tamanho do AccountIconWrapper da tabela da Gestão da Prévia; a cor vem de getAccountIcon
export const AccountIcon = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 18px;
  height: 18px;

  svg {
    width: 18px !important;
    height: 18px !important;
  }

  & > div {
    min-width: 18px !important;
  }
`

export const EmptyText = styled(Box)`
  ${({ theme }) => css`
    font-size: 14px;
    color: ${theme.colors.secondary};
  `}
`

export const Timeline = styled(Box)`
  display: flex;
  flex-direction: column;
`

export const TimelineItem = styled(Box)`
  ${({ theme }) => css`
    position: relative;
    display: flex;
    gap: 32px;
    padding: 0 0 24px 20px;

    /* linha vertical ligando os ícones */
    &:not(:last-child)::before {
      content: '';
      position: absolute;
      left: 36px;
      top: 36px;
      bottom: 0;
      width: 1px;
      background: ${theme.colors.blue.head};
    }
  `}
`

export const StatusIcon = styled(Box)`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ItemBody = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 4px;
`

export const ItemHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const StatusLabel = styled(Box)`
  ${({ theme }) => css`
    font-size: 16px;
    font-weight: 600;
    color: ${theme.colors.secondary};
  `}
`

export const LatestTag = styled(Box)`
  ${({ theme }) => css`
    font-size: 10px;
    color: ${theme.colors.green[500]};
  `}
`

export const ItemDate = styled(Box)`
  ${({ theme }) => css`
    font-size: 11px;
    color: ${theme.colors.primary};
  `}
`

export const ItemDetails = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 8px;

  & > div {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`

export const ItemText = styled(Box)`
  ${({ theme }) => css`
    font-size: 11px;
    color: ${theme.colors.primary};
  `}
`

export const Amount = styled(Box)`
  ${({ theme }) => css`
    font-size: 16px;
    color: ${theme.colors.primary};
  `}
`

export const Footer = styled(Box)`
  ${({ theme }) => css`
    margin: 0 24px;
    padding: 12px 0 24px;
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid ${theme.colors.blue.head};
  `}
`
